import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { MediaPreview } from '@anytag/shared-atoms';
import { ImageSlider } from '@anytag/shared-molecules';

export interface MediaPreviewSliderProps {
  data?: string[];
  className?: string;
  currentMediaIndex?: number;
  onMediaChange?: (index: number, media: string) => void;
}

export const MediaPreviewSlider = ({
  className,
  data = [],
  onMediaChange,
  currentMediaIndex
}: MediaPreviewSliderProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn('mt-2', className)}>
      <p className="mb-2 text-sm font-semibold">
        {`${t('General.Post')} ${(currentMediaIndex || 0) + 1} / ${data.length}`}
      </p>
      <ImageSlider total={data.length} css={{ '& .slick-track': { marginLeft: '0' } }}>
        {data.map((image, index) => (
          <MediaPreview
            key={index}
            src={image}
            objectFit="contain"
            onClick={() => onMediaChange?.(index, image)}
            className={cn('size-24 border-3', currentMediaIndex === index ? 'border-[red]' : 'border-transparent')}
          />
        ))}
      </ImageSlider>
    </div>
  );
};
